import { GetApplicationRolesRoutine } from '~modules/Auth/redux-routines';

export const initialState = {
  data: [],
  error: null,
  isFetching: false,
};

export const applicationRolesReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case GetApplicationRolesRoutine.REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case GetApplicationRolesRoutine.SUCCESS: {
      return {
        ...state,
        data: action.payload,
        isFetching: false,
      };
    }
    case GetApplicationRolesRoutine.FAILURE:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      };

    default:
      return state;
  }
};
